//
// ValueGroup.js
// BIRD
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "@sas-dvr/ltjs-commons/moduleBuilder";
import EventDispatcher from "@sas-dvr/ltjs-commons/events/EventDispatcher";
import "../../lib";
import "../../models/BIRDModel";

var ValueGroup = createModule("BIRD::ValueGroup", ["commons::PropertyOwner","commons::BaseModel","BIRD::BIRDModel"], EventDispatcher, [
    ,
    {
        sourceValues: [7],
        groupValue: 7,
    },
    ,
    ,
    ,
    {
        _create_v: [4],
        _create_so: [4,7,[7]],
    },
    ,
    ["_create"]
]);
export default ValueGroup;
